import { GeneralServiceResponse } from "../../hooks/useGetGeneralData";

export function downloadCsv(
  data: GeneralServiceResponse,
  start?: string | Date,
  end?: string | Date,
  filename?: string
) {
  if (!data || data.length === 0) {
    return;
  }
  // Detectar si hay atributos extendidos (EXO1)
  const hasExtended = (data as any[]).some((d) =>
    d && (
      d.profundidad !== undefined ||
      d.ph !== undefined ||
      d.orp !== undefined ||
      d.clorofila !== undefined ||
      d.oxigeno_disuelto !== undefined ||
      d.oxigeno_saturacion !== undefined ||
      d.nitrato !== undefined ||
      d.amonio !== undefined ||
      d.cianobacterias !== undefined
    )
  );

  const hasBuoy = (data as any[]).some((d) =>
    d && (
      d.temperatura_agua !== undefined ||
      d.presion_atmosferica !== undefined ||
      d.velocidad_viento !== undefined ||
      d.velocidad_corriente !== undefined ||
      d.ola_altura_significativa !== undefined
    )
  );

  const hasNivelMar = (data as any[]).some((d) =>
    d && d.nivel_mar !== undefined
  );
  const hasNasa = (data as any[]).some((d) =>
    d && d.temperatura_nasa !== undefined
  );

  const nasaCols = hasNasa ? ['temperatura_nasa'] : [];
  const baseCols = ['recvTime','temperatura', ...nasaCols, 'conductividad','turbidez','latitud','longitud'];
  const extendedCols = [
    'salinidad','profundidad','ph','orp','clorofila','oxigeno_disuelto','oxigeno_saturacion','nitrato','amonio','cianobacterias','voltaje_device','temperatura_device'
  ];
  const buoyCols = [
    'temperatura_agua',
    'temperatura_ambiente',
    'presion_atmosferica',
    'precipitacion',
    'velocidad_viento',
    'direccion_viento',
    'velocidad_corriente',
    'direccion_corriente',
    'ola_altura_significativa',
    'ola_altura_maxima',
    'ola_direccion_media',
    'ola_periodo_pico',
    'bateria_porcentaje',
    'bateria_wh'
  ];

  const cols = hasBuoy
    ? [...baseCols.slice(0, 1), ...buoyCols, ...baseCols.slice(1)]
    : hasExtended
      ? [...baseCols.slice(0, 4), ...extendedCols, ...baseCols.slice(4)]
      : hasNivelMar
        ? ['recvTime', 'nivel_mar', ...nasaCols, 'latitud', 'longitud']
      : baseCols;
  const header = cols.join(',') + '\n';
  const rows = data.map((d: any) => {
    const date = new Date(d.recvTime).toISOString();
    const values: Record<string, any> = {
      recvTime: date,
      temperatura: d.temperatura ?? '',
      temperatura_nasa: d.temperatura_nasa ?? '',
      conductividad: d.conductividad ?? '',
      turbidez: d.turbidez ?? '',
      salinidad: d.salinidad ?? '',
      profundidad: d.profundidad ?? '',
      ph: d.ph ?? '',
      orp: d.orp ?? '',
      clorofila: d.clorofila ?? '',
      oxigeno_disuelto: d.oxigeno_disuelto ?? '',
      oxigeno_saturacion: d.oxigeno_saturacion ?? '',
      nitrato: d.nitrato ?? '',
      amonio: d.amonio ?? '',
      cianobacterias: d.cianobacterias ?? '',
      voltaje_device: d.voltaje_device ?? '',
      temperatura_device: d.temperatura_device ?? '',
      temperatura_agua: d.temperatura_agua ?? '',
      temperatura_ambiente: d.temperatura_ambiente ?? '',
      presion_atmosferica: d.presion_atmosferica ?? '',
      precipitacion: d.precipitacion ?? '',
      velocidad_viento: d.velocidad_viento ?? '',
      direccion_viento: d.direccion_viento ?? '',
      velocidad_corriente: d.velocidad_corriente ?? '',
      direccion_corriente: d.direccion_corriente ?? '',
      ola_altura_significativa: d.ola_altura_significativa ?? '',
      ola_altura_maxima: d.ola_altura_maxima ?? '',
      ola_direccion_media: d.ola_direccion_media ?? '',
      ola_periodo_pico: d.ola_periodo_pico ?? '',
      bateria_porcentaje: d.bateria_porcentaje ?? '',
      bateria_wh: d.bateria_wh ?? '',
      nivel_mar: d.nivel_mar ?? '',
      latitud: d.latitud ?? '',
      longitud: d.longitud ?? '',
    };
    return cols.map((c) => values[c]).join(',');
  });
  const csvContent = header + rows.join('\n');
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;

  let finalName = filename || 'series.csv';
  if (start && end) {
    const toDate = (d: string | Date) => (typeof d === 'string' ? new Date(d) : d);
    const pad = (n: number) => n.toString().padStart(2, '0');
    const fmt = (d: Date) =>
      `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}_${pad(d.getHours())}-${pad(d.getMinutes())}-${pad(d.getSeconds())}`;
    const startDate = toDate(start);
    const endDate = toDate(end);
    finalName = `series_${fmt(startDate)}_to_${fmt(endDate)}.csv`;
  }

  link.setAttribute('download', finalName);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}
